/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CommitProfileUpdateDTO = {
    /**
     * Job ID returned from profile selfie submission
     */
    jobId: string;
    /**
     * Must be UPDATE_EMAIL or UPDATE_PHONE
     */
    purpose: CommitProfileUpdateDTO.purpose;
    /**
     * Token returned from OTP verify step
     */
    updateToken: string;
};

export namespace CommitProfileUpdateDTO {

    /**
     * Must be UPDATE_EMAIL or UPDATE_PHONE
     */
    export enum purpose {
        SIGN_IN = 'SIGN_IN',
        NON_CUSTOMER_SIGN_UP = 'NON_CUSTOMER_SIGN_UP',
        CUSTOMER_SIGN_UP = 'CUSTOMER_SIGN_UP',
        TRANSACTION_PIN = 'TRANSACTION_PIN',
        CHANGE_PROFILE = 'CHANGE_PROFILE',
        CHANGE_PROFILE_PASSWORD = 'CHANGE_PROFILE_PASSWORD',
        TWO_FACTOR = 'TWO_FACTOR',
        MISMATCH_SIGN_UP = 'MISMATCH_SIGN_UP',
        CHANGE_OF_DEVICE = 'CHANGE_OF_DEVICE',
        SECURE_TRANSACTION = 'SECURE_TRANSACTION',
        UPDATE_EMAIL = 'UPDATE_EMAIL',
        UPDATE_PHONE = 'UPDATE_PHONE',
    }


}
